import type { MeResponse } from '@mmf/contracts';

/**
 * Your own identity/role/status — moved off every page and onto its own
 * route. The one thing that stays visible everywhere is the suspended
 * notice (App.tsx's SignedInContent) — that's actionable wherever you are,
 * not something you'd otherwise have to come here to discover.
 */
export function AccountPage({ principal }: { principal: MeResponse }): React.JSX.Element {
  return (
    <section aria-labelledby="account-heading">
      <h2 id="account-heading">Your Account</h2>

      <dl className="facts">
        <dt>Roles</dt>
        <dd data-testid="roles">{principal.roles.join(', ')}</dd>

        <dt>Status</dt>
        <dd data-testid="status">{principal.status}</dd>

        {principal.ownedCategories.length > 0 && (
          <>
            <dt>Categories you own</dt>
            <dd data-testid="owned-categories">{principal.ownedCategories.join(', ')}</dd>
          </>
        )}
      </dl>

      {principal.isBreakGlassAdmin && (
        <p className="notice" data-testid="breakglass-notice">
          You hold Administrator through the break-glass group rather than a role granted in the
          forum. This is intended for recovery and bootstrap, not day-to-day use.
        </p>
      )}
    </section>
  );
}
